var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.656,
    height: 24.492,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.934 0H2.721A2.724 2.724 0 0 0 0 2.721v19.05a2.724 2.724 0 0 0 2.721 2.721h27.214a2.724 2.724 0 0 0 2.721-2.721V2.721A2.724 2.724 0 0 0 29.934 0M2.721 1.361h27.214a1.3 1.3 0 0 1 .283.057c-2.356 2.156-10.168 9.3-12.9 11.766a1.365 1.365 0 0 1-1.975 0c-2.734-2.463-10.546-9.61-12.9-11.765a1.3 1.3 0 0 1 .278-.058m-1.36 20.41V2.721a1.3 1.3 0 0 1 .076-.376C3.24 4 8.691 8.982 12.225 12.2 8.7 15.223 3.25 20.392 1.433 22.125a1.3 1.3 0 0 1-.072-.354m28.574 1.361H2.721a1.3 1.3 0 0 1-.307-.062c1.878-1.79 7.365-6.989 10.826-9.95l1.188 1.075a2.72 2.72 0 0 0 3.8 0l1.189-1.076c3.461 2.961 8.948 8.159 10.826 9.95a1.3 1.3 0 0 1-.309.062Zm1.365-1.361a1.3 1.3 0 0 1-.072.355c-1.818-1.734-7.27-6.9-10.793-9.929 3.535-3.214 8.985-8.2 10.789-9.851a1.3 1.3 0 0 1 .076.376Z",
    "data-name": "Path 550"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/emailWhite.fc1fc52a91d485c0c236bea4029b59cb.svg";
export { ForwardRef as ReactComponent };